import { css } from 'styled-components';

export const NormalizeStyles = css`
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    appearance: none;
  }
`;
